import { Select } from 'antd'
import { get } from 'lodash'
import { convertDate } from '../ConverDate/convertdate.dependencies'
const { Option, OptGroup } = Select

const SelectDependencies = (props) => {
  const { typeTask, dataSelect, onChange } = props
  return (
    <Select
      allowClear
      optionLabelProp='label'
      size='large'
      showSearch
      filterOption={(input, option) => {
        const keyMatch = get(option, 'key', '')
        return keyMatch.toLowerCase().includes(input.toLocaleLowerCase())
      }}
      onChange={onChange}
    >
      <OptGroup
        label={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginLeft: '16px',
              marginTop: '16px',
            }}
          >
            <div style={{ color: '#101828', fontSize: '16px' }}>
              {typeTask === 'task' ? 'Task name' : 'Sub Task name'}
            </div>
            <div style={{ color: '#101828', fontSize: '16px' }}>Planned date</div>
          </div>
        }
      >
        {dataSelect?.map((e) => (
          <Option
            key={`${e?.title}`}
            value={e?.sprintflow_id}
            label={e?.title}
            style={{ padding: '16px 12px 16px 30px' }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ color: '#101828', fontSize: '16px' }}>{e?.title}</div>
              <div style={{ color: '#101828', fontSize: '16px' }}>
                {convertDate(e?.plan_start, e?.plan_end)}
              </div>
            </div>
          </Option>
        ))}
      </OptGroup>
    </Select>
  )
}

export default SelectDependencies
